export default __webpack_public_path__ + "static/media/profile-icon.a07a1c9f.svg";